import { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

const FAQS = [
  {
    q: 'What areas in The Gambia does GAMBGO deliver to?',
    a: 'We currently deliver across the Greater Banjul Area and the Kombos, including Sukuta, Serrekunda, Bakau, Kanifing, and surrounding neighbourhoods. New areas are added regularly.',
  },
  {
    q: 'How much is the delivery fee?',
    a: 'Delivery fees are calculated by distance and shown upfront before you pay. Short trips start at D120, and you will always see the exact fee in your cart before checkout.',
  },
  {
    q: 'Can I order from more than one restaurant at the same time?',
    a: 'Yes. You can add items from multiple restaurants or stores to one order. The primary restaurant sets the delivery fee, and we handle the rest.',
  },
  {
    q: 'How do I track my order?',
    a: 'Once your order is accepted, you can track it live in the app. You will see when the restaurant is preparing your meal, when a rider is assigned, and when they are on the way to your door.',
  },
  {
    q: 'What payment methods are accepted?',
    a: 'We accept cash on delivery, Wave, and selected card and bank transfer options. Available methods are shown at checkout.',
  },
  {
    q: 'How do I become a vendor or driver?',
    a: 'Tap "Become a vendor" or "Drive with GAMBGO" on this page to start your application. Our team reviews every submission and will guide you through onboarding.',
  },
];

export const FAQ = () => {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-landing-surface px-4 py-16 sm:py-20">
      <div className="mx-auto max-w-3xl">
        <h2 className="mb-10 text-center text-3xl font-bold tracking-tight text-landing-ink sm:mb-14 sm:text-4xl">
          Frequently asked questions
        </h2>

        <div className="space-y-4">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className="rounded-2xl border border-border bg-background px-5 py-4 transition-shadow hover:shadow-sm"
              >
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="text-base font-semibold text-landing-ink sm:text-lg">
                    {item.q}
                  </span>
                  <span className="shrink-0 rounded-full bg-brand/10 p-1.5 text-brand">
                    {isOpen ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
                  </span>
                </button>
                {isOpen && (
                  <p className="mt-3 max-w-2xl text-sm leading-relaxed text-muted-foreground sm:text-base">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
